
export const state = () => ({
    notifyList: [
        // {
        //     content: "我要砍价了，你快点搁劳资回复。砍价商品DE11F4，快去看看吧~",
        //     eventId: 1955833408126976000,
        //     eventType: "NORMAL",
        //     icon: "https://pzdsoss.pzds.com/c/2/game/icon/20250305/admin_J2cDCdTS.png",
        //     time: 1755142597062,
        //     title: "砍价出价通知",
        //     links: [
        //         {
        //             channel: "PC",
        //             linkType: "INNER",
        //             params: "sessionId=DE11F4_1000454129_1000454418&goodsNo=DE11F4",
        //             scene: "BARGAIN_CHAT",
        //             url: "page2/goodsList",
        //         }
        //     ]
        // }
    ]
})

export const mutations = {
    /**
     * 设置消息列表
     * @param {*} state 状态树
     * @param {*} data 数据
     */
    SET_NOTIFY_LIST(state, data) {
        state.notifyList = data
    },
    /**
     * 清空消息列表
     * @param {*} state 状态树
     */
    CLEAR_NOTIFY_LIST(state) {
        state.notifyList = []
    },
    /**
     * 移除列表中的数据
     * @param {*} state 状态树
     * @param {*} data 数据
     */
    REMOVE_NOTIFY_LIST(state, index) {
        state.notifyList.splice(index, 1)
    }
}

export const actions = {
    async setNotifyList({ commit, state }, data) {

        const list = [...state.notifyList]
        list.push(data)
        const audio = new Audio(`https://oss.pzds.com/mobileV3/message-prompt.mp3`)
        audio.play().catch(e => console.warn('播放提示音失败', e))
        commit('SET_NOTIFY_LIST', list)
    },

}
export const getters = {
    notifyList: state => state.notifyList

}
